<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'statistics'
};
</script>

<style lang="less" scoped></style>
